var _path, _path2, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 1C9 0.723858 9.22386 0.5 9.5 0.5C9.77614 0.5 10 0.723858 10 1V10C10 10.2761 9.77614 10.5 9.5 10.5C9.22386 10.5 9 10.2761 9 10V1Z",
    fill: "#0E1219"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 10.5C0.223858 10.5 -9.78514e-09 10.2761 -2.18557e-08 10C-3.39263e-08 9.72386 0.223858 9.5 0.5 9.5L9.5 9.5C9.77614 9.5 10 9.72386 10 10C10 10.2761 9.77614 10.5 9.5 10.5L0.5 10.5Z",
    fill: "#0E1219"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 1.19922,
    width: 0.988242,
    height: 13.1539,
    rx: 0.494121,
    transform: "rotate(-45 0 1.19922)",
    fill: "#0E1219"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.9c8302941d1a94d3e67affb98e995e8a.svg";
export { ForwardRef as ReactComponent };